export default __webpack_public_path__ + "static/media/updateLikes.4e460b55.graphql";